import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function DeleteSessionIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d="M3 6H5H21" stroke="#F04438" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fill="transparent"
        d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V6H19Z"
        stroke="#F04438"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 11V17" stroke="#F04438" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 11V17" stroke="#F04438" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}
